export const onRowUpdateError = (pushNotification, I18n) => {
    pushNotification({
        open: true,
        message: I18n.translate`Somethings went wrong update field`,
        type: "error",
        timeout: "short",
    });
};
